import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import BorderColorIcon from "@mui/icons-material/BorderColor";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Link,
  Tooltip,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import SlidingPanel from "react-sliding-side-panel";
import Attachment from "../../../../../Components/Broker/Attachment/Attachment";
import DetailPolicyHistory from "../../../../../Components/Broker/DetailPolicyHistory/DetailPolicyHistory";
import EmailComponent from "../../../../../Components/Broker/EmailComponent/EmailComponent";
import FeaturesAndExclusion from "../../../../../Components/Broker/FeaturesAndExclusion/FeaturesAndExclusion";
import LogsTable from "../../../../../Components/Broker/LogsTable/LogsTable";
import NotesSection from "../../../../../Components/Broker/NotesSection/NotesSection";
import TasksSection from "../../../../../Components/Broker/TasksSection/TasksSection";
import BulkUploadForm from "../../../../../Components/Common/BulkUploadFormSP/BulkUploadForm";
import RemovePopup from "../../../../../Components/Common/CarForm/RemovePopup/RemovePopup";
import PostQueryForm from "../../../../../Components/Common/PostQuerySP/PostQueryForm";
import MultipleSearchDropdown from "../../../../../Supporting files/MultipleSearchDropdown/MultipleSearchDropdown";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import RKTextFieldDisable from "../../../../../Supporting files/RKTextFieldDisable/RKTextFieldDisable";
import SearchDropdownDisable from "../../../../../Supporting files/SearchDropdownDisable/SearchDropdownDisable";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import SelectDropdownDisable from "../../../../../Supporting files/SelectDropdownDisable/SelectDropdownDisable";
import PolicyConfig from "../../Policies/PolicyDetail/PolicyConfig/PolicyConfig";

function QuoteDetails() {
  const navigate = useNavigate();
  const [viewTabsStatus, setViewTabsStatus] = React.useState("overview");
  const [subSection, setSubSection] = React.useState("businesscard");
  const [sectionStatus, SetSectionStatus] =
    React.useState<string>("personalDetails");
  const [postQueryForm, setPostQueryForm] = React.useState(false);
  const [editShow, setEditShow] = React.useState(false);
  const [insurerName, setInsurerName] = React.useState("Sbi");
  const [cDBalance, setCDBalance] = React.useState("₹ 8,00,000");
  const [salesPerson, setSalesPerson] = React.useState("#US6789-Kartike");
  const [servicingPartner, setServicingPartner] =
    React.useState("#US6789-Udit");
  const [premium, setPremium] = React.useState("₹ 10,00,000");
  const [tpa, setTpa] = React.useState("Tpa1");
  const [organizationName, setOrganizationName] = React.useState("Evervent");
  const [organizationEmail, setOrganizationEmail] = React.useState(
    "evervent@domain.com"
  );
  const [organizationContact, setOrganizationContact] =
    React.useState("9876543210");
  const [locations, setLocations] = React.useState("Chandigarh");
  const [designation, setDesignation] = React.useState("");
  const [relationManager, setRelationManager] = React.useState("#US6789-Rahul");
  const [officeAddress, setOfficeAddress] = React.useState("Chandigarh");
  const [empGradeData, setEmpGradeData] = useState<
    Array<{
      sum_insured: string;
      emp_count: string;
      deleteable: boolean;
      features: Array<string>;
    }>
  >([{ sum_insured: "", emp_count: "", deleteable: false, features: [] }]);
  const [voluntryCoverage, setVoluntryCoverage] = React.useState(
    "Employees+Dependents"
  );

  const [voluntryPaymentFreq, setVoluntryPaymentFreq] =
    React.useState("Monthly");
  const [voluntryValue, setVoluntryValue] = React.useState("Rupee");
  const [startDate, setStartDate] = React.useState<Date | null>(new Date());
  const [endDate, setEndDate] = React.useState<Date | null>(new Date());
  const [priorityStatus, setPriorityStatus] = React.useState("Pending");
  const [removeStatus, setRemoveStatus] = React.useState(false);
  const [attachment, setAttachment] = React.useState(false);
  const [emailcomp, setEmailComp] = React.useState(false);
  const [planType, setPlanType] = React.useState(0);
  const [basicConfiguration, setBasicConfiguration] = React.useState("1E");
  const [indvConfiguration, setIndvConfiguration] = React.useState("1P");
  const [othersGraded, setOthersGraded] = React.useState("");
  const [familyDefinition, setFamilyDefinition] = React.useState(
    "Employee, Spouse & 2 dependant Children up to the age of 25 years"
  );
  const [location, setLocation] = React.useState("");
  const [gradedDesignation, setGradedDesignation] = React.useState("Salary");
  const [insurer1, setInsurer1] = React.useState("Reliance");
  const [insurer2, setInsurer2] = React.useState("Reliance");
  const [insurer3, setInsurer3] = React.useState("Reliance");
  const [insurer4, setInsurer4] = React.useState("Reliance");
  const [netpremium1, setNetPremium1] = React.useState("1,00,000");
  const [netpremium2, setNetPremium2] = React.useState("1,00,000");
  const [netpremium3, setNetPremium3] = React.useState("1,00,000");
  const [netpremium4, setNetPremium4] = React.useState("1,00,000");
  const [grosspremium1, setGrossPremium1] = React.useState("1,18,000");
  const [grosspremium2, setGrossPremium2] = React.useState("1,18,000");
  const [grosspremium3, setGrossPremium3] = React.useState("1,18,000");
  const [grosspremium4, setGrossPremium4] = React.useState("1,18,000");
  const [tax, setTax] = React.useState("18,000");
  // const [tax2, setTax2] = React.useState("18,000");
  // const [tax3, setTax3] = React.useState("18,000");
  // const [tax4, setTax4] = React.useState("18,000");
  const [location1, setLocation1] = React.useState("Chandigarh");
  const [location2, setLocations2] = React.useState("Chandigarh");
  const [location3, setLocations3] = React.useState("Chandigarh");
  const [location4, setLocations4] = React.useState("Chandigarh");
  const [corporatebufferValue, setCorporateBufferValue] =
    React.useState("₹ 10,00,000");

  const [spocContact, setSpocContact] = React.useState("");
  const [openContactForm, setOpenContactForm] = React.useState(false);
  const [contactName, setContactName] = React.useState("");
  const [contactOrganization, setContactOrganization] = React.useState("");
  const [contactDepartment, setContactDepartment] = React.useState("");
  const [jobTitle, setJobTitle] = React.useState("");
  const [contactEmail, setContactEmail] = React.useState("");
  const [contactMobile, setContactMobile] = React.useState("");
  const [contactNumber, setContactNumber] = React.useState("");
  const [currentEmployer, setCurrentEmployer] = React.useState("");
  const [uploadFile, setUploadFile] = React.useState(false);
  const [removeCategory, setRemoveCategory] = React.useState(false);
  const [toggle, setToggle] = React.useState(true);
  const [expanded, setExpanded] = React.useState<string | false>("panel1");
  const [gradedSectionData, setGradedSectionDta] = useState(0);
  const [voluntaryGradedSectionData, setVoluntaryGradedSectionData] =
    useState(0);
  const [gradeLives, setGradeLives] = React.useState("150");
  const [sumInsuredOne, setSumInsuredOne] = React.useState("₹3,00,000");
  const [ageTableDetails, setAgeTableDetails] = useState(0);
  const [relatioshipLiveDetails, setRelatioshipLiveDetails] = useState(0);
  const [gradecriterion, setGradeCriterion] = useState(0);
  const [showcorporate, setShowcorporate] = useState(false);
  const [sumInsuredTwo, setSumInsuredTwo] = React.useState("₹3,00,000");
  // for scrolling
  const policyDetails = useRef(null);
  const insurerDetails = useRef(null);
  const organizationDetails = useRef(null);
  const servicingDetails = useRef(null);
  const attatchmentsdetails = useRef(null);
  const emaildetails = useRef(null);
  const taskdetails = useRef(null);

  const scrollToSection = (elementRef: any) => {
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  // function toggleShowhealth() {
  //   setShowhealth(!showhealth);
  // }

  const prioritystatusData = [
    { key: "Pending", value: "Pending" },
    { key: "Expired", value: "Expired" },
    { key: "Active", value: "Active" },
    { key: "Rejected", value: "Rejected" },
    { key: "Inprogress", value: "Inprogress" },
  ];
  const contact_organization_data = [
    { key: "Evervent", value: "Evervent" },
    { key: "Amazon", value: "Amazon" },
    { key: "Infosys", value: "Infosys" },
    { key: "Google", value: "Google" },
    { key: "Microsoft", value: "Microsoft" },
  ];
  const sumInsuredOne_data = [
    { key: "₹3,00,000", value: "₹ 3,00,000" },
    { key: "₹4,00,000", value: "₹ 4,00,000" },
  ];

  const designation_data = [
    { key: "Ass. Manager", year: "Ass. Manager" },
    { key: "Trainee", year: "Trainee" },
    { key: "Deeputy Manager", year: "Deeputy Manager" },
    { key: "Branch Manager", year: "Branch Manager" },
  ];
  const locations_data = [
    { key: "Chandigarh", year: "Chandigarh" },
    { key: "Dehradun", year: "Dehradun" },
    { key: "Mohali", year: "Mohali" },
    { key: "Gurugram", year: "Gurugram" },
  ];
  const spoc_contact_data = [
    { key: "EV0065VikasSaini", value: "EV0065 Vikas Saini" },
    { key: "EV0016KartikeKakkar", value: "EV0016 Kartike Kakkar" },
  ];
  const contact_department_data = [
    { key: "Engineering", value: "Engineering" },
    { key: "IT", value: "IT" },
    { key: "Human Resource", value: "Human Resource" },
    { key: "Business Development", value: "Business Development" },
    { key: "Designing", value: "Designing" },
    { key: "Management", value: "Management" },
  ];
  const current_employer_data = [
    { key: "Evervent", value: "Evervent" },
    { key: "Amazon", value: "Amazon" },
    { key: "Infosys", value: "Infosys" },
    { key: "Google", value: "Google" },
    { key: "Microsoft", value: "Microsoft" },
  ];
  const job_title_data = [
    {
      key: "Associate Frontend Developer",
      value: "Associate Frontend Developer",
    },
    { key: "Hr", value: "Hr" },
    { Key: "QA Engineer", value: "QA Engineer" },
  ];
  const voluntrycoverage_data = [
    { key: "Employees+Dependents", value: "Employees + Dependents" },
    { key: "Employees+Dependents", value: "Employees + Dependents" },
    { key: "Employees+Dependents", value: "Employees + Dependents" },
    { key: "Employees+Dependents", value: "Employees + Dependents" },
  ];
  const voluntrypaymentfreq_data = [
    { key: "Monthly", value: "Monthly" },
    { key: "Quarterly", value: "Quarterly" },
    { key: "Yearly", value: "Yearly" },
  ];
  const voluntryvalue_data = [
    { key: "Rupee", value: "Rupee" },
    { key: "U.S. Dollar", value: "U.S. Dollar" },
    { key: "Canadian Dollar", value: "Canadian Dollar" },
  ];

  const basicConfig_data = [
    { key: "1E", value: "1E" },
    { key: "1E+1S", value: "1E + 1S" },
    { key: "1E+1S+1C", value: "1E + 1S + 1C" },
    { key: "1E+1S+1C+1C", value: "1E + 1S + 1C + 1C" },
  ];
  const indvConfig_data = [
    { key: "NIL", value: "NIL" },
    { key: "1P", value: "1P + 1P" },
    { key: "1PIL", value: "1PIL + 1PIL" },
    { key: "1P+1P+1PIL+1PIL", value: "1P + 1P + 1PIL + 1PIL" },
  ];
  const gradedDesignation_data = [
    { key: "Salary Grade", value: "Salary Grade" },
    { key: "Salary", value: "Salary" },
    { key: "Designation", value: "Designation" },
    { key: "Region", value: "Region" },
    { key: "Department", value: "Department" },
    { key: "Others", value: "Others" },
  ];

  const sumInsuredTwo_data = [
    { key: "₹3,00,000", value: "₹ 3,00,000" },
    { key: "₹4,00,000", value: "₹ 4,00,000" },
  ];
  const insurer_data = [
    { label: "Sbi", value: "SBI General Insurance" },
    { label: "Religare", value: "Religare General Insurance" },
    { label: "digit", value: "Digit General Insurance" },
    { label: "reliance", value: "Reliance General Insurance" },
    { label: "MaxBupa", value: "Max Bupa Life Insurance" },
  ];
  const officeAddress_data = [
    { label: "Mohali", value: "Mohali" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Dehradun", value: "Dehradun" },
    { label: "Karnal", value: "Karnal" },
  ];

  //******************** */
  const [notesData, setNotesData] = useState<
    Array<{ name: string; date: Date; description: string }>
  >([]);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const updateMasterState = (attrName: any, value: any) => {
    if (attrName[0] === "rateData") {
    } else {
      // let data: any = [...rateData];
      // setRateData([...data]);
      if (attrName === "notes_new_data") {
        setNotesData((notesData) => [
          ...notesData,
          { name: "Umesh", date: new Date(), description: value },
        ]);
      } else {
        attrName(value);
      }
    }
  };

  const [ageData, setAgeData] = React.useState([
    [
      { key: "one", value: "10" },
      { key: "two", value: "10" },
      { key: "three", value: "10" },
      { key: "four", value: "10" },
      { key: "five", value: "10" },
      { key: "six", value: "10" },
      { key: "seven", value: "10" },
      { key: "eight", value: "10" },
      { key: "nine", value: "10" },
    ],
  ]);
  function toggleShowcorporate() {
    setShowcorporate(!showcorporate);
  }

  const [livesinformationData, setLivesInformationData] = React.useState([
    {
      min_age: "19",
      max_age: "80",
      relationship: "Self",
      noof_lives: "50",
    },
    {
      min_age: "19",
      max_age: "80",
      relationship: "Spouse",
      noof_lives: "50",
    },
    {
      min_age: "0",
      max_age: "25",
      relationship: "Son",
      noof_lives: "50",
    },
    {
      min_age: "0",
      max_age: "25",
      relationship: "Daughter",
      noof_lives: "50",
    },
    {
      min_age: "19",
      max_age: "80",
      relationship: "Father",
      noof_lives: "50",
    },
    {
      min_age: "19",
      max_age: "80",
      relationship: "Mother",
      noof_lives: "50",
    },
    {
      min_age: "19",
      max_age: "80",
      relationship: "Father In Law",
      noof_lives: "50",
    },
    {
      min_age: "19",
      max_age: "80",
      relationship: "Mother In Law",
      noof_lives: "50",
    },
  ]);

  return (
    <Box className="layoutWrapper">
      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate("/homebroker?page=quote");
            }}
          >
            <ChevronLeftIcon />
          </Link>
          <span className="detailIcon">E</span>
          <div>
            <h3>Evervent #QEOUF7894326</h3>
            {/* <p>Policy No. :34545545646CN0001</p> */}
          </div>
        </Grid>
        <Grid
          xs={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          <div>
            <Tooltip title="Remove">
              <Link
                underline="none"
                className="actionLinks red_icon"
                onClick={() => {
                  setRemoveStatus(true);
                }}
              >
                <DeleteOutlineIcon />
              </Link>
            </Tooltip>
          </div>
          <div>
            <Tooltip title="Global Edit">
              <Link className="actionLinks" onClick={() => {}}>
                <BorderColorIcon />
              </Link>
            </Tooltip>
          </div>
          {/* Status Dropdown */}
          <div id={priorityStatus}>
            <div className="status_dropdown" id={priorityStatus}>
              {priorityStatus === "Highest" || priorityStatus === "Active" ? (
                <CheckCircleIcon id={priorityStatus} />
              ) : priorityStatus == "" || priorityStatus === "Rejected" ? (
                <CancelIcon id={priorityStatus} />
              ) : priorityStatus == "Pending" ? (
                <HourglassTopIcon id={priorityStatus} />
              ) : priorityStatus == "Inprogress" ? (
                <PublishedWithChangesIcon id={priorityStatus} />
              ) : priorityStatus == "Expired" ? (
                <HistoryToggleOffIcon id={priorityStatus} />
              ) : null}
              <SelectDropdown
                class_name="inputFieldd"
                title=""
                value={priorityStatus}
                attrName={setPriorityStatus}
                value_update={updateMasterState}
                dropdown_data={prioritystatusData}
                warn_status={false}
              />
            </div>
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection h-100">
              <Link
                className={
                  sectionStatus === "policyDetails"
                    ? "active sectionLink policyDetails"
                    : "sectionLink policyDetails"
                }
                onClick={() => {
                  scrollToSection(policyDetails);
                  SetSectionStatus("policyDetails");
                }}
              >
                <span> Policy Details</span>
              </Link>

              {/* <Link
                className={
                  sectionStatus === "insurerDetails"
                    ? "active sectionLink insurerDetails"
                    : "sectionLink insurerDetails"
                }
                onClick={() => {
                  scrollToSection(insurerDetails);
                  SetSectionStatus("insurerDetails");
                }}
              >
                <span>Insurer Details</span>
              </Link> */}
              <Link
                className={
                  sectionStatus === "organizationDetails"
                    ? "active sectionLink organizationDetails"
                    : "sectionLink organizationDetails"
                }
                onClick={() => {
                  scrollToSection(organizationDetails);
                  SetSectionStatus("organizationDetails");
                }}
              >
                <span>Organization Details</span>
              </Link>
              <Link
                className={
                  sectionStatus === "servicingDetails"
                    ? "active sectionLink servicingDetails"
                    : "sectionLink servicingDetails"
                }
                onClick={() => {
                  scrollToSection(servicingDetails);
                  SetSectionStatus("servicingDetails");
                }}
              >
                <span>Servicing Details</span>
              </Link>

              <Link
                className={
                  sectionStatus === "attatchmentsdetails"
                    ? "active sectionLink attatchmentsdetails"
                    : "sectionLink attatchmentsdetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(attatchmentsdetails);
                  SetSectionStatus("attatchmentsdetails");
                }}
              >
                <span>Attatchments</span>
              </Link>
              <Link
                className={
                  sectionStatus === "emaildetails"
                    ? "active sectionLink emaildetails"
                    : "sectionLink emaildetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(emaildetails);
                  SetSectionStatus("emaildetails");
                }}
              >
                <span>Email</span>
              </Link>
              <Link
                className={
                  sectionStatus === "taskdetails"
                    ? "active sectionLink taskdetails"
                    : "sectionLink taskdetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(taskdetails);
                  SetSectionStatus("taskdetails");
                }}
              >
                <span>Task</span>
              </Link>
            </Grid>
            <Grid xs className="rightSection h-100">
              <Grid container spacing={3} alignItems="center">
                <Grid xl={7} lg={8} md={10} xs={12} className="pl-0">
                  <div className="productTabs ">
                    <Button
                      className={
                        viewTabsStatus == "overview"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "overview");
                      }}
                    >
                      Overview
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "Insurer"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "Insurer");
                      }}
                    >
                      Insurer
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "History"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "History");
                      }}
                    >
                      Policy History
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "Configuration"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "Configuration");
                      }}
                    >
                      Configuration
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "Features"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "Features");
                      }}
                    >
                      Features & Exclusions
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "Voluntaryplans"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "Voluntaryplans");
                      }}
                    >
                      Voluntary Plans
                    </Button>
                    {/* <Button
                      className={
                        viewTabsStatus == "CDLedger"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "CDLedger");
                      }}
                    >
                      CD Ledger
                    </Button> */}
                    <Button
                      className={
                        viewTabsStatus == "Logs"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "Logs");
                      }}
                    >
                      Logs
                    </Button>
                    <Button
                      className={
                        viewTabsStatus == "notes"
                          ? "defaultTab active"
                          : "defaultTab"
                      }
                      onClick={() => {
                        updateMasterState(setViewTabsStatus, "notes");
                      }}
                    >
                      Notes
                    </Button>
                  </div>
                </Grid>
                <Grid
                  xl={5}
                  lg={4}
                  md={2}
                  xs={12}
                  style={{ textAlign: "right" }}
                  className="text-sm-center"
                >
                  <p className="lastupdate">
                    Last Update: 11:00AM, 10th Nov, 2022
                  </p>
                </Grid>
              </Grid>
              {viewTabsStatus == "overview" ? (
                <>
                  <Grid container spacing={3}>
                    <Grid xs={9} className="pl-0">
                      <div className="client_info_section">
                        <p className="client_info_p freshPolicy md_width">
                          Fresh Policy
                        </p>
                        <p className="client_info_p empID md_width">
                          Employees : <span>50</span>
                        </p>
                        <p className="client_info_p dependents md_width">
                          Dependents: <span>50</span>
                        </p>
                        <p className="client_info_p totalEmployees md_width mr-0">
                          Lives: <span>100</span>
                        </p>
                      </div>
                    </Grid>
                    <Grid xs={3} className="align-self-center text-right">
                      <Link className="networkhosplist">
                        Network Hospital List
                      </Link>
                    </Grid>
                  </Grid>

                  {/* organization detail section */}
                  <Box className="detailSection" ref={organizationDetails}>
                    <div className="sectionTitle">
                      <h4>Organization Details</h4>
                    </div>
                    <Grid container spacing={3}>
                      <Grid
                        sm={12}
                        style={{ display: "flex", flexWrap: "wrap" }}
                      >
                        <div className="client_organization">
                          <h6>
                            Organization Name <span>Evervent</span>
                          </h6>
                        </div>
                        <div className="client_organization">
                          <h6>
                            Ownership <span>Pvt. Ltd.</span>
                          </h6>
                        </div>
                        <div className="client_organization">
                          <h6>
                            Industry <span>Information Technology</span>
                          </h6>
                        </div>
                        <div className="client_organization">
                          <h6>
                            Sub - Industry <span>Softare & Services</span>
                          </h6>
                        </div>
                        <div className="client_organization">
                          <h6>
                            Client ID <span>CLT23456789</span>
                          </h6>
                        </div>
                        <div className="client_organization">
                          <h6>
                            Parent Client ID<span>CLT789056</span>
                          </h6>
                        </div>
                        <div className="client_organization">
                          <h6>
                            Parent Organization<span>Evervent Pvt Ltd</span>
                          </h6>
                        </div>
                        <div className="client_organization">
                          <h6>
                            Email<span>everevent@domain.com</span>
                          </h6>
                        </div>
                        <div className="client_organization">
                          <h6>
                            Website<span>www.evervent.in</span>
                          </h6>
                        </div>
                        <div className="client_organization">
                          <h6>
                            Contact No.<span>9876543210</span>
                          </h6>
                        </div>
                      </Grid>
                      <Grid sm={6}>
                        <MultipleSearchDropdown
                          class_name="inputField"
                          title="Locations"
                          value={locations}
                          attrName={setLocations}
                          value_update={updateMasterState}
                          multiple_data={locations_data}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                  {/* product Detail section */}
                  <Box className="detailSection" ref={policyDetails}>
                    <div className="sectionTitle">
                      <h4>Product Details</h4>
                    </div>
                    <Grid container spacing={3}>
                      <Grid md={5} lg={4} xl={3}>
                        <div className="planname">
                          <p>
                            <span className="group_health"></span>Group Health
                            Insurance
                          </p>
                        </div>
                      </Grid>
                    </Grid>
                  </Box>
                  {/* attachment section */}
                  <Box className="detailSection" ref={attatchmentsdetails}>
                    <div className="sectionTitle">
                      <h4>Attatchments</h4>
                      <div className="actionBtns">
                        {/* <Link
                          className="redBtn delete"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Delete
                        </Link> */}

                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => setUploadFile(true)}
                        >
                          Add New
                        </Link>
                      </div>
                    </div>
                    <Attachment
                      open_status={attachment}
                      attrName={setAttachment}
                      value_update={updateMasterState}
                    />
                  </Box>

                  {/* Email section */}
                  <Box className="detailSection" ref={emaildetails}>
                    <div className="sectionTitle">
                      <h4>Emails </h4>
                      <div className="actionBtns">
                        <Link
                          className="redBtn delete"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Delete
                        </Link>

                        <Link
                          className="blueBtn edit"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Compose
                        </Link>
                      </div>
                    </div>

                    {/* Attachment Section Start*/}

                    <EmailComponent
                      open_status={emailcomp}
                      attrName={setEmailComp}
                      value_update={updateMasterState}
                    />
                    {/* Attachment Section End*/}
                  </Box>

                  {/* Task Section */}
                  <Grid container spacing={3} className="px-0">
                    <Grid xs={12}>
                      <Box className="detailSection mb-0" ref={taskdetails}>
                        <div className="sectionTitle">
                          <h4>Tasks </h4>
                          <div className="actionBtns">
                            <Link
                              className="blueBtn addfile"
                              sx={{
                                textDecoration: "none",
                                cursor: "pointer",
                              }}
                            >
                              Add Task
                            </Link>
                          </div>
                        </div>
                        <div className="mx-3">
                          <TasksSection />
                        </div>
                      </Box>
                    </Grid>
                  </Grid>
                </>
              ) : null}
              {viewTabsStatus == "Insurer" ? (
                <>
                  {/* INSURER Details */}
                  <Grid container spacing={3} className="px-0">
                    <Grid xs={12}>
                      <Box className="detailSection mb-0">
                        <div className="sectionTitle">
                          <h4>Insurer Details</h4>
                        </div>

                        <Box className="employeeDetail w-100">
                          {empGradeData.map((data, index) => (
                            <Accordion
                              className="Accordion_section gradedSection gradepadding"
                              onChange={handleChange("panel1")}
                            >
                              <Grid container spacing={0}>
                                <Grid xs={4} className="px-0">
                                  <AccordionSummary
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    style={{
                                      display: "inline-block",
                                    }}
                                  >
                                    <Typography
                                      className="title"
                                      style={{ width: "800px" }}
                                    >
                                      <h5>Insurer Name</h5>
                                    </Typography>
                                  </AccordionSummary>
                                </Grid>
                                <Grid
                                  xs={8}
                                  style={{
                                    alignSelf: "Center",
                                    display: "flex",
                                    justifyContent: "end",
                                  }}
                                >
                                  {data.deleteable == false ? null : (
                                    <div
                                      className="text-right"
                                      style={{ alignSelf: "center" }}
                                    >
                                      <Link
                                        className="redBtn delete ml-3"
                                        underline="none"
                                        onClick={() => {
                                          setEmpGradeData((addFeature) =>
                                            empGradeData.filter(
                                              (_, i) => i !== index
                                            )
                                          );
                                        }}
                                      >
                                        Remove
                                      </Link>
                                    </div>
                                  )}
                                  <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                  >
                                    <Typography></Typography>
                                  </AccordionSummary>
                                </Grid>
                              </Grid>

                              <AccordionDetails style={{ padding: "0" }}>
                                {/* Inner content */}
                                <Grid container spacing={3}>
                                  <Grid sm={12} md={6} lg={3} xl={3}>
                                    <SearchDropdownDisable
                                      class_name="inputField"
                                      title="Select Insurer"
                                      value={insurer1}
                                      attrName={setInsurer1}
                                      value_update={updateMasterState}
                                      data={insurer_data}
                                      warn_status={false}
                                      error_message="Please select client"
                                    />
                                  </Grid>
                                  <Grid sm={12} md={6} lg={3} xl={3}>
                                    <SearchDropdownDisable
                                      class_name="inputField"
                                      title="Location"
                                      value={location}
                                      attrName={setLocation}
                                      value_update={updateMasterState}
                                      data={officeAddress_data}
                                      warn_status={false}
                                      error_message="Please select office address"
                                    />
                                  </Grid>
                                  <Grid sm={12} md={6} lg={3} xl={3}>
                                    <RKTextFieldDisable
                                      class_name="inputField"
                                      title="Net Premium"
                                      value={netpremium1}
                                      attrName={setNetPremium1}
                                      value_update={updateMasterState}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid sm={12} md={6} lg={3} xl={3}>
                                    <RKTextFieldDisable
                                      class_name="inputField"
                                      title="Gross Premium"
                                      value={grosspremium1}
                                      attrName={setGrossPremium1}
                                      value_update={updateMasterState}
                                      warn_status={false}
                                    />
                                    <p className="small-text text-right">
                                      Tax @18% = ₹ 18,000
                                    </p>
                                  </Grid>
                                  <Grid xs={12} style={{ textAlign: "right" }}>
                                    <div className="actionBtns">
                                      <Link
                                        className="blueBtn addfile"
                                        sx={{
                                          textDecoration: "none",
                                          cursor: "pointer",
                                        }}
                                        onClick={() => setUploadFile(true)}
                                      >
                                        Add Documents
                                      </Link>
                                    </div>
                                  </Grid>
                                  <Grid xs={12}>
                                    <Attachment
                                      open_status={attachment}
                                      attrName={setAttachment}
                                      value_update={updateMasterState}
                                    />
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                              {/* </div> */}
                            </Accordion>
                          ))}
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </>
              ) : null}
              {viewTabsStatus == "History" ? <DetailPolicyHistory /> : null}
              {viewTabsStatus == "Configuration" ? (
                <>
                  <PolicyConfig />
                </>
              ) : // <Grid container spacing={3}>
              //   <Grid xs={12}>
              //     <Box className="detailSection">
              //       <div className="sectionTitle">
              //         <h4>Plan Details</h4>
              //       </div>
              //       <Grid container spacing={3}>
              //         <Grid xs={4}>
              //           <Grid container spacing={3} className="px-0">
              //             <Grid xs={12}>
              //               <h5 className="plan_type mb-0">Plan Type</h5>
              //             </Grid>
              //             <Grid xs={12}>
              //               <Box className="plantTypeView">
              //                 <div className="select_plan_inner">
              //                   <h5>Graded Coverage</h5>
              //                   <p>
              //                     Different average amount for different
              //                     employees in the policy.
              //                   </p>
              //                 </div>
              //               </Box>
              //             </Grid>
              //           </Grid>
              //         </Grid>
              //         <Grid xs={8}>
              //           <Box className="coverageDetail">
              //             <Grid container spacing={3} className="px-0">
              //               <Grid xs={12}>
              //                 <h5 className="empsecHeading">Coverage Type</h5>
              //               </Grid>
              //               <Grid xs={12}>
              //                 <Box className="coverageTypeView">
              //                   <Grid container spacing={3}>
              //                     <Grid xs={12} className="px-0">
              //                       <ul className="coverage_type_section ">
              //                         <li>
              //                           <div className="coverage_box employee">
              //                             <p>Employee</p>
              //                           </div>
              //                         </li>
              //                         <li>
              //                           <div className="coverage_box spouse">
              //                             <p>Spouse</p>
              //                           </div>
              //                         </li>
              //                         <li>
              //                           <div className="coverage_box kids">
              //                             <p>Children</p>
              //                           </div>
              //                         </li>
              //                       </ul>
              //                     </Grid>
              //                   </Grid>
              //                 </Box>
              //               </Grid>
              //             </Grid>
              //           </Box>
              //         </Grid>

              //         <Grid xs={12} className="px-0">

              //           <Box className="coverageDetail">
              //             <Grid container spacing={3}>
              //               <Grid xs={12}>
              //                 <h5 className="subHeading">
              //                   Coverage Configuration
              //                 </h5>
              //               </Grid>

              //               <Grid sm={6} md={4} lg={3} xl={3}>
              //                 <SelectDropdownDisable
              //                   class_name="inputField"
              //                   title="Basic Configuration"
              //                   value={basicConfiguration}
              //                   attrName={setBasicConfiguration}
              //                   value_update={updateMasterState}
              //                   dropdown_data={basicConfig_data}
              //                   warn_status={false}
              //                 />
              //               </Grid>
              //               <Grid sm={6} md={4} lg={3} xl={3}>
              //                 <SelectDropdownDisable
              //                   class_name="inputField"
              //                   title="Individual Configuration"
              //                   value={indvConfiguration}
              //                   attrName={setIndvConfiguration}
              //                   value_update={updateMasterState}
              //                   dropdown_data={indvConfig_data}
              //                   warn_status={false}
              //                 />
              //               </Grid>
              //               <Grid sm={12} md={8} lg={6} xl={4}>
              //                 <RKTextFieldDisable
              //                   class_name="inputField"
              //                   title="Family Definition"
              //                   value={familyDefinition}
              //                   attrName={setFamilyDefinition}
              //                   value_update={updateMasterState}
              //                   warn_status={false}
              //                 />
              //               </Grid>
              //             </Grid>

              //             <Grid container spacing={3}>
              //               <Grid xs={12}>
              //                 <h5 className="subHeading">
              //                   Criterion for Grade Creation
              //                 </h5>
              //               </Grid>
              //               <Grid sm={6} md={4} lg={3} xl={3}>
              //                 <SelectDropdownDisable
              //                   class_name="inputField"
              //                   title="Select Criterion"
              //                   value={gradedDesignation}
              //                   attrName={setGradedDesignation}
              //                   value_update={updateMasterState}
              //                   dropdown_data={gradedDesignation_data}
              //                   warn_status={false}
              //                 />
              //               </Grid>
              //               {gradedDesignation === "Others" ? (
              //                 <Grid sm={6} md={4} lg={4} xl={3}>
              //                   <RKTextFieldDisable
              //                     class_name="inputField"
              //                     title="Other - Input grade Criteria"
              //                     value={othersGraded}
              //                     attrName={setOthersGraded}
              //                     value_update={updateMasterState}
              //                     warn_status={false}
              //                   />
              //                 </Grid>
              //               ) : null}
              //             </Grid>
              //           </Box>
              //         </Grid>
              //       </Grid>
              //     </Box>

              //     <Box className="detailSection">
              //       <div className="sectionTitle">
              //         <h4>Information on Grade Criterion</h4>
              //         <div className="total_lives">
              //           <p>
              //             300 <span>Total Lives</span>
              //           </p>
              //         </div>
              //       </div>
              //       <div className="policy_lives">
              //         <Grid container spacing={3}>
              //           {planType === 0 ? (
              //             <>
              //               <Grid sm={12} md={7} lg={10}>
              //                 <ul className="coverageAmt">
              //                   <li>
              //                     <div className="radioBox ">
              //                       <input
              //                         type="radio"
              //                         name="coveragess"
              //                         onClick={() => setGradeCriterion(0)}
              //                       />
              //                       <label>Grade 1</label>
              //                     </div>
              //                   </li>
              //                   <li>
              //                     <div className="radioBox">
              //                       <input
              //                         type="radio"
              //                         name="coveragess"
              //                         onClick={() => setGradeCriterion(1)}
              //                       />
              //                       <label>Grade 2</label>
              //                     </div>
              //                   </li>
              //                   <li>
              //                     <div className="radioBox">
              //                       <input
              //                         type="radio"
              //                         name="coveragess"
              //                         defaultChecked
              //                         onClick={() => setGradeCriterion(2)}
              //                       />
              //                       <label>Grade 3</label>
              //                     </div>
              //                   </li>
              //                   <li>
              //                     <div className="radioBox">
              //                       <input
              //                         type="radio"
              //                         name="coveragess"
              //                         onClick={() => setGradeCriterion(3)}
              //                       />
              //                       <label>Grade 4</label>
              //                     </div>
              //                   </li>
              //                   <li>
              //                     <div className="radioBox">
              //                       <input
              //                         type="radio"
              //                         name="coveragess"
              //                         onClick={() => setGradeCriterion(4)}
              //                       />
              //                       <label>Grade 5</label>
              //                     </div>
              //                   </li>
              //                 </ul>
              //               </Grid>
              //             </>
              //           ) : null}
              //           <Grid sm={6} md={3} lg={2}>
              //             <SelectDropdownDisable
              //               class_name="inputField"
              //               title="Sum Insured"
              //               value={sumInsuredOne}
              //               attrName={setSumInsuredOne}
              //               value_update={updateMasterState}
              //               dropdown_data={sumInsuredOne_data}
              //               warn_status={false}
              //             />
              //           </Grid>
              //           {gradecriterion === 0 ? (
              //             <>
              //               <div className="quotedetail_field">
              //                 <Grid container spacing={3}>
              //                   <Grid xs={8}>
              //                     <MultipleSearchDropdown
              //                       class_name="inputField"
              //                       title="Designation"
              //                       value={designation}
              //                       attrName={setDesignation}
              //                       value_update={updateMasterState}
              //                       multiple_data={designation_data}
              //                     />
              //                   </Grid>
              //                 </Grid>
              //               </div>
              //             </>
              //           ) : null}
              //           {gradecriterion === 1 ? (
              //             <div className="quotedetail_field">
              //               <Grid container spacing={3}>
              //                 <Grid xs={8}>
              //                   <MultipleSearchDropdown
              //                     class_name="inputField"
              //                     title="Designation"
              //                     value={designation}
              //                     attrName={setDesignation}
              //                     value_update={updateMasterState}
              //                     multiple_data={designation_data}
              //                   />
              //                 </Grid>
              //               </Grid>
              //             </div>
              //           ) : null}
              //           {gradecriterion === 2 ? (
              //             <div className="quotedetail_field">
              //               <Grid container spacing={3}>
              //                 <Grid xs={8}>
              //                   <MultipleSearchDropdown
              //                     class_name="inputField"
              //                     title="Designation"
              //                     value={designation}
              //                     attrName={setDesignation}
              //                     value_update={updateMasterState}
              //                     multiple_data={designation_data}
              //                   />
              //                 </Grid>
              //               </Grid>
              //             </div>
              //           ) : null}
              //           {gradecriterion === 3 ? (
              //             <div className="quotedetail_field">
              //               <Grid container spacing={3}>
              //                 <Grid xs={8}>
              //                   <MultipleSearchDropdown
              //                     class_name="inputField"
              //                     title="Designation"
              //                     value={designation}
              //                     attrName={setDesignation}
              //                     value_update={updateMasterState}
              //                     multiple_data={designation_data}
              //                   />
              //                 </Grid>
              //               </Grid>
              //             </div>
              //           ) : null}
              //           {gradecriterion === 4 ? (
              //             <div className="quotedetail_field">
              //               <Grid container spacing={3}>
              //                 <Grid xs={8}>
              //                   <MultipleSearchDropdown
              //                     class_name="inputField"
              //                     title="Designation"
              //                     value={designation}
              //                     attrName={setDesignation}
              //                     value_update={updateMasterState}
              //                     multiple_data={designation_data}
              //                   />
              //                 </Grid>
              //               </Grid>
              //             </div>
              //           ) : null}
              //         </Grid>
              //       </div>
              //     </Box>

              //     <Box className="detailSection">
              //       <div className="sectionTitle">
              //         <h4>Plans Settings</h4>
              //       </div>

              //       <Grid container spacing={3}>
              //         <Grid
              //           sm={12}
              //           md={8}
              //           lg={6}
              //           className="switchFields"
              //           display={"flex"}
              //           alignItems="center"
              //           sx={{ height: "70px" }}>
              //           <span>Corporate Buffer</span>
              //           <input
              //             type="checkbox"
              //             className="switch"
              //             onClick={toggleShowcorporate}
              //           />

              //           {toggle == showcorporate ? (
              //             <div className="ml-2" style={{ width: "250px" }}>
              //               <RKTextFieldDisable
              //                 class_name="inputField"
              //                 title="Corporate Buffer Value"
              //                 value={corporatebufferValue}
              //                 attrName={setCorporateBufferValue}
              //                 value_update={updateMasterState}
              //                 warn_status={false}
              //               />
              //             </div>
              //           ) : null}
              //         </Grid>
              //       </Grid>
              //     </Box>

              //     <Box className="detailSection">
              //       <div className="sectionTitle">
              //         <h4>Lives Information</h4>
              //         <div className="total_lives">
              //           <p>
              //             300 <span>Total Lives</span>
              //           </p>
              //         </div>
              //       </div>
              //       <div className="policy_lives">
              //         <Grid container spacing={3}>
              //           {planType === 0 ? (
              //             <>
              //               <Grid sm={12} md={7} lg={8}>
              //                 <ul className="coverageAmt">
              //                   <li>
              //                     <div className="radioBox ">
              //                       <input
              //                         type="radio"
              //                         name="coverages"
              //                         onClick={() =>
              //                           setRelatioshipLiveDetails(0)
              //                         }
              //                       />
              //                       <label>Grade 1</label>
              //                     </div>
              //                   </li>
              //                   <li>
              //                     <div className="radioBox">
              //                       <input
              //                         type="radio"
              //                         name="coverages"
              //                         onClick={() =>
              //                           setRelatioshipLiveDetails(1)
              //                         }
              //                       />
              //                       <label>Grade 2</label>
              //                     </div>
              //                   </li>
              //                   <li>
              //                     <div className="radioBox">
              //                       <input
              //                         type="radio"
              //                         name="coverages"
              //                         defaultChecked
              //                         onClick={() =>
              //                           setRelatioshipLiveDetails(2)
              //                         }
              //                       />
              //                       <label>Grade 3</label>
              //                     </div>
              //                   </li>
              //                   <li>
              //                     <div className="radioBox">
              //                       <input
              //                         type="radio"
              //                         name="coverages"
              //                         onClick={() =>
              //                           setRelatioshipLiveDetails(3)
              //                         }
              //                       />
              //                       <label>Grade 4</label>
              //                     </div>
              //                   </li>
              //                   <li>
              //                     <div className="radioBox">
              //                       <input
              //                         type="radio"
              //                         name="coverages"
              //                         onClick={() =>
              //                           setRelatioshipLiveDetails(4)
              //                         }
              //                       />
              //                       <label>Grade 5</label>
              //                     </div>
              //                   </li>
              //                 </ul>
              //               </Grid>
              //             </>
              //           ) : null}
              //           <Grid sm={6} md={2} lg={2}>
              //             <RKTextField
              //               class_name="inputField"
              //               title="Grade Lives"
              //               value={gradeLives}
              //               attrName={setGradeLives}
              //               value_update={updateMasterState}
              //               warn_status={false}
              //             />
              //           </Grid>
              //           <Grid sm={6} md={3} lg={2}>
              //             <SelectDropdownDisable
              //               class_name="inputField"
              //               title="Sum Insured"
              //               value={sumInsuredOne}
              //               attrName={setSumInsuredOne}
              //               value_update={updateMasterState}
              //               dropdown_data={sumInsuredOne_data}
              //               warn_status={false}
              //             />
              //           </Grid>

              //           {relatioshipLiveDetails === 0 ? (
              //             <Grid xs={12}>
              //               <div className="table">
              //                 <div className="age-table">
              //                   <ul className="heading">
              //                     <li>0 - 18 yrs</li>
              //                     <li>19 yrs - 35 yrs</li>
              //                     <li>36 yrs - 45 yrs</li>
              //                     <li>46 yrs - 55 yrs</li>
              //                     <li>56 yrs - 60 yrs</li>
              //                     <li>61 yrs - 65 yrs</li>
              //                     <li>66 yrs - 70 yrs</li>
              //                     <li>71 yrs - 75 yrs</li>
              //                     <li>76 yrs - 80 yrs</li>
              //                   </ul>

              //                   {ageData.map((agemainData, agemainIndex) => (
              //                     <ul className="subheading">
              //                       {agemainData.map(
              //                         (agesubData, agesubIndex) => (
              //                           <li>
              //                             <RKTextField
              //                               class_name="inputField"
              //                               title=""
              //                               value={agesubData.value}
              //                               attrName={[
              //                                 "ageData",
              //                                 agemainIndex,
              //                                 agesubIndex,
              //                                 agesubData.key,
              //                               ]}
              //                               value_update={updateMasterState}
              //                               warn_status={false}
              //                             />
              //                           </li>
              //                         )
              //                       )}
              //                     </ul>
              //                   ))}
              //                 </div>
              //               </div>
              //             </Grid>
              //           ) : null}

              //           {relatioshipLiveDetails === 1 ? (
              //             <Grid xs={12}>
              //               <div className="table">
              //                 <div className="age-table">
              //                   <ul className="heading">
              //                     <li>0 - 18 yrs</li>
              //                     <li>19 yrs - 35 yrs</li>
              //                     <li>36 yrs - 45 yrs</li>
              //                     <li>46 yrs - 55 yrs</li>
              //                     <li>56 yrs - 60 yrs</li>
              //                     <li>61 yrs - 65 yrs</li>
              //                     <li>66 yrs - 70 yrs</li>
              //                     <li>71 yrs - 75 yrs</li>
              //                     <li>76 yrs - 80 yrs</li>
              //                   </ul>

              //                   {ageData.map((agemainData, agemainIndex) => (
              //                     <ul className="subheading">
              //                       {agemainData.map(
              //                         (agesubData, agesubIndex) => (
              //                           <li>
              //                             <RKTextField
              //                               class_name="inputField"
              //                               title=""
              //                               value={agesubData.value}
              //                               attrName={[
              //                                 "ageData",
              //                                 agemainIndex,
              //                                 agesubIndex,
              //                                 agesubData.key,
              //                               ]}
              //                               value_update={updateMasterState}
              //                               warn_status={false}
              //                             />
              //                           </li>
              //                         )
              //                       )}
              //                     </ul>
              //                   ))}
              //                 </div>
              //               </div>
              //             </Grid>
              //           ) : null}

              //           {relatioshipLiveDetails === 2 ? (
              //             <Grid xs={12}>
              //               <div className="table">
              //                 <div className="age-table">
              //                   <ul className="heading">
              //                     <li>0 - 18 yrs</li>
              //                     <li>19 yrs - 35 yrs</li>
              //                     <li>36 yrs - 45 yrs</li>
              //                     <li>46 yrs - 55 yrs</li>
              //                     <li>56 yrs - 60 yrs</li>
              //                     <li>61 yrs - 65 yrs</li>
              //                     <li>66 yrs - 70 yrs</li>
              //                     <li>71 yrs - 75 yrs</li>
              //                     <li>76 yrs - 80 yrs</li>
              //                   </ul>

              //                   {ageData.map((agemainData, agemainIndex) => (
              //                     <ul className="subheading">
              //                       {agemainData.map(
              //                         (agesubData, agesubIndex) => (
              //                           <li>
              //                             <RKTextField
              //                               class_name="inputField"
              //                               title=""
              //                               value={agesubData.value}
              //                               attrName={[
              //                                 "ageData",
              //                                 agemainIndex,
              //                                 agesubIndex,
              //                                 agesubData.key,
              //                               ]}
              //                               value_update={updateMasterState}
              //                               warn_status={false}
              //                             />
              //                           </li>
              //                         )
              //                       )}
              //                     </ul>
              //                   ))}
              //                 </div>
              //               </div>
              //             </Grid>
              //           ) : null}

              //           {relatioshipLiveDetails === 3 ? (
              //             <Grid xs={12}>
              //               <div className="table">
              //                 <div className="age-table">
              //                   <ul className="heading">
              //                     <li>0 - 18 yrs</li>
              //                     <li>19 yrs - 35 yrs</li>
              //                     <li>36 yrs - 45 yrs</li>
              //                     <li>46 yrs - 55 yrs</li>
              //                     <li>56 yrs - 60 yrs</li>
              //                     <li>61 yrs - 65 yrs</li>
              //                     <li>66 yrs - 70 yrs</li>
              //                     <li>71 yrs - 75 yrs</li>
              //                     <li>76 yrs - 80 yrs</li>
              //                   </ul>

              //                   {ageData.map((agemainData, agemainIndex) => (
              //                     <ul className="subheading">
              //                       {agemainData.map(
              //                         (agesubData, agesubIndex) => (
              //                           <li>
              //                             <RKTextField
              //                               class_name="inputField"
              //                               title=""
              //                               value={agesubData.value}
              //                               attrName={[
              //                                 "ageData",
              //                                 agemainIndex,
              //                                 agesubIndex,
              //                                 agesubData.key,
              //                               ]}
              //                               value_update={updateMasterState}
              //                               warn_status={false}
              //                             />
              //                           </li>
              //                         )
              //                       )}
              //                     </ul>
              //                   ))}
              //                 </div>
              //               </div>
              //             </Grid>
              //           ) : null}

              //           {relatioshipLiveDetails === 4 ? (
              //             <Grid xs={12}>
              //               <div className="table">
              //                 <div className="age-table">
              //                   <ul className="heading">
              //                     <li>0 - 18 yrs</li>
              //                     <li>19 yrs - 35 yrs</li>
              //                     <li>36 yrs - 45 yrs</li>
              //                     <li>46 yrs - 55 yrs</li>
              //                     <li>56 yrs - 60 yrs</li>
              //                     <li>61 yrs - 65 yrs</li>
              //                     <li>66 yrs - 70 yrs</li>
              //                     <li>71 yrs - 75 yrs</li>
              //                     <li>76 yrs - 80 yrs</li>
              //                   </ul>

              //                   {ageData.map((agemainData, agemainIndex) => (
              //                     <ul className="subheading">
              //                       {agemainData.map(
              //                         (agesubData, agesubIndex) => (
              //                           <li>
              //                             <RKTextField
              //                               class_name="inputField"
              //                               title=""
              //                               value={agesubData.value}
              //                               attrName={[
              //                                 "ageData",
              //                                 agemainIndex,
              //                                 agesubIndex,
              //                                 agesubData.key,
              //                               ]}
              //                               value_update={updateMasterState}
              //                               warn_status={false}
              //                             />
              //                           </li>
              //                         )
              //                       )}
              //                     </ul>
              //                   ))}
              //                 </div>
              //               </div>
              //             </Grid>
              //           ) : null}
              //         </Grid>
              //       </div>
              //     </Box>

              //     <Box className="detailSection">
              //       <div className="sectionTitle">
              //         <h4>Relationship-Lives Information</h4>
              //         <div className="total_lives">
              //           <p>
              //             400 <span>Total Lives</span>
              //           </p>
              //         </div>
              //       </div>
              //       <div className="policy_lives">
              //         <Grid container spacing={3}>
              //           {planType === 0 ? (
              //             <Grid sm={12} md={12} lg={8}>
              //               <ul className="coverageAmt">
              //                 <li>
              //                   <div className="radioBox ">
              //                     <input
              //                       type="radio"
              //                       name="coveragesd"
              //                       onClick={() => setAgeTableDetails(0)}
              //                     />
              //                     <label>Grade 1</label>
              //                   </div>
              //                 </li>
              //                 <li>
              //                   <div className="radioBox">
              //                     <input
              //                       type="radio"
              //                       name="coveragesd"
              //                       defaultChecked
              //                       onClick={() => setAgeTableDetails(1)}
              //                     />
              //                     <label>Grade 2</label>
              //                   </div>
              //                 </li>
              //                 <li>
              //                   <div className="radioBox">
              //                     <input
              //                       type="radio"
              //                       name="coveragesd"
              //                       onClick={() => setAgeTableDetails(2)}
              //                     />
              //                     <label>Grade 3</label>
              //                   </div>
              //                 </li>
              //                 <li>
              //                   <div className="radioBox">
              //                     <input
              //                       type="radio"
              //                       name="coveragesd"
              //                       onClick={() => setAgeTableDetails(3)}
              //                     />
              //                     <label>Grade 4</label>
              //                   </div>
              //                 </li>
              //                 <li>
              //                   <div className="radioBox">
              //                     <input
              //                       type="radio"
              //                       name="coveragesd"
              //                       onClick={() => setAgeTableDetails(4)}
              //                     />
              //                     <label>Grade 5</label>
              //                   </div>
              //                 </li>
              //               </ul>
              //             </Grid>
              //           ) : null}
              //           <Grid sm={12} md={6} lg={4}>
              //             <SelectDropdownDisable
              //               class_name="inputField"
              //               title="Sum Insured"
              //               value={sumInsuredTwo}
              //               attrName={setSumInsuredTwo}
              //               value_update={updateMasterState}
              //               dropdown_data={sumInsuredTwo_data}
              //               warn_status={false}
              //             />
              //           </Grid>
              //           {ageTableDetails === 0 ? (
              //             <Grid xs={12}>
              //               <div className="table">
              //                 <div className="livesinformation-table">
              //                   <ul className="heading">
              //                     <li>Min. Age</li>
              //                     <li>Max. Age</li>
              //                     <li>Relationship</li>
              //                     <li>No. Of Lives</li>
              //                   </ul>

              //                   {livesinformationData.map((data, index) => (
              //                     <ul className="subheading">
              //                       <li>{data.min_age}</li>
              //                       <li>{data.max_age}</li>
              //                       <li>{data.relationship}</li>
              //                       <li>{data.noof_lives}</li>
              //                     </ul>
              //                   ))}
              //                 </div>
              //               </div>
              //             </Grid>
              //           ) : null}

              //           {ageTableDetails === 1 ? (
              //             <Grid xs={12}>
              //               <div className="table">
              //                 <div className="livesinformation-table">
              //                   <ul className="heading">
              //                     <li>Min. Age</li>
              //                     <li>Max. Age</li>
              //                     <li>Relationship</li>
              //                     <li>No. Of Lives</li>
              //                   </ul>

              //                   {livesinformationData.map((data, index) => (
              //                     <ul className="subheading">
              //                       <li>{data.min_age}</li>
              //                       <li>{data.max_age}</li>
              //                       <li>{data.relationship}</li>
              //                       <li>{data.noof_lives}</li>
              //                     </ul>
              //                   ))}
              //                 </div>
              //               </div>
              //             </Grid>
              //           ) : null}

              //           {ageTableDetails === 2 ? (
              //             <Grid xs={12}>
              //               <div className="table">
              //                 <div className="livesinformation-table">
              //                   <ul className="heading">
              //                     <li>Min. Age</li>
              //                     <li>Max. Age</li>
              //                     <li>Relationship</li>
              //                     <li>No. Of Lives</li>
              //                   </ul>

              //                   {livesinformationData.map((data, index) => (
              //                     <ul className="subheading">
              //                       <li>{data.min_age}</li>
              //                       <li>{data.max_age}</li>
              //                       <li>{data.relationship}</li>
              //                       <li>{data.noof_lives}</li>
              //                     </ul>
              //                   ))}
              //                 </div>
              //               </div>
              //             </Grid>
              //           ) : null}

              //           {ageTableDetails === 3 ? (
              //             <Grid xs={12}>
              //               <div className="table">
              //                 <div className="livesinformation-table">
              //                   <ul className="heading">
              //                     <li>Min. Age</li>
              //                     <li>Max. Age</li>
              //                     <li>Relationship</li>
              //                     <li>No. Of Lives</li>
              //                   </ul>

              //                   {livesinformationData.map((data, index) => (
              //                     <ul className="subheading">
              //                       <li>{data.min_age}</li>
              //                       <li>{data.max_age}</li>
              //                       <li>{data.relationship}</li>
              //                       <li>{data.noof_lives}</li>
              //                     </ul>
              //                   ))}
              //                 </div>
              //               </div>
              //             </Grid>
              //           ) : null}

              //           {ageTableDetails === 4 ? (
              //             <Grid xs={12}>
              //               <div className="table">
              //                 <div className="livesinformation-table">
              //                   <ul className="heading">
              //                     <li>Min. Age</li>
              //                     <li>Max. Age</li>
              //                     <li>Relationship</li>
              //                     <li>No. Of Lives</li>
              //                   </ul>

              //                   {livesinformationData.map((data, index) => (
              //                     <ul className="subheading">
              //                       <li>{data.min_age}</li>
              //                       <li>{data.max_age}</li>
              //                       <li>{data.relationship}</li>
              //                       <li>{data.noof_lives}</li>
              //                     </ul>
              //                   ))}
              //                 </div>
              //               </div>
              //             </Grid>
              //           ) : null}
              //         </Grid>
              //       </div>
              //     </Box>
              //   </Grid>
              // </Grid>
              null}
              {viewTabsStatus == "Features" ? (
                <Box className="voluntry_plans_outer">
                  {planType === 0 ? (
                    <>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <ul className="coverageAmt">
                            <li>
                              <div className="radioBox ">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => setGradedSectionDta(0)}
                                  defaultChecked
                                />
                                <label>Grade 1</label>
                              </div>
                            </li>
                            <li>
                              <div className="radioBox">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => setGradedSectionDta(1)}
                                />
                                <label>Grade 2</label>
                              </div>
                            </li>
                            <li>
                              <div className="radioBox">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => setGradedSectionDta(2)}
                                />
                                <label>Grade 3</label>
                              </div>
                            </li>
                            <li>
                              <div className="radioBox">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => setGradedSectionDta(3)}
                                />
                                <label>Grade 4</label>
                              </div>
                            </li>
                            <li>
                              <div className="radioBox">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => setGradedSectionDta(4)}
                                />
                                <label>Grade 5</label>
                              </div>
                            </li>
                          </ul>
                        </Grid>
                      </Grid>
                    </>
                  ) : null}
                  {gradedSectionData === 0 ? (
                    <>
                      <FeaturesAndExclusion />
                    </>
                  ) : null}
                  {gradedSectionData === 1 ? (
                    <>
                      <FeaturesAndExclusion />
                    </>
                  ) : null}
                  {gradedSectionData === 2 ? (
                    <>
                      <FeaturesAndExclusion />
                    </>
                  ) : null}
                  {gradedSectionData === 3 ? (
                    <>
                      <FeaturesAndExclusion />
                    </>
                  ) : null}
                  {gradedSectionData === 4 ? (
                    <>
                      <FeaturesAndExclusion />
                    </>
                  ) : null}
                </Box>
              ) : null}

              {viewTabsStatus == "Voluntaryplans" ? (
                <Box className="voluntry_plans_outer common_accordion">
                  {planType === 0 ? (
                    <>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <ul className="coverageAmt">
                            <li>
                              <div className="radioBox ">
                                <input
                                  type="radio"
                                  name="coverages"
                                  defaultChecked
                                  onClick={() => {
                                    setVoluntaryGradedSectionData(0);
                                  }}
                                />
                                <label>Grade 1</label>
                              </div>
                            </li>
                            <li>
                              <div className="radioBox">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => {
                                    setVoluntaryGradedSectionData(1);
                                  }}
                                />
                                <label>Grade 2</label>
                              </div>
                            </li>
                            <li>
                              <div className="radioBox">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => {
                                    setVoluntaryGradedSectionData(2);
                                  }}
                                />
                                <label>Grade 3</label>
                              </div>
                            </li>
                            <li>
                              <div className="radioBox">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => {
                                    setVoluntaryGradedSectionData(3);
                                  }}
                                />
                                <label>Grade 4</label>
                              </div>
                            </li>
                            <li>
                              <div className="radioBox">
                                <input
                                  type="radio"
                                  name="coverages"
                                  onClick={() => {
                                    setVoluntaryGradedSectionData(4);
                                  }}
                                />
                                <label>Grade 5</label>
                              </div>
                            </li>
                          </ul>
                        </Grid>
                      </Grid>
                    </>
                  ) : null}
                  {voluntaryGradedSectionData === 0 ||
                  voluntaryGradedSectionData === 1 ? (
                    <Grid
                      container
                      spacing={3}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Grid xs={12}>
                        <div>
                          <Accordion
                            className="Accordion_section"
                            expanded={expanded === "panel1"}
                            onChange={handleChange("panel1")}
                          >
                            <AccordionSummary
                              // expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <Typography className="title">
                                Group Personal Accident
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Coverage"
                                      value={voluntryCoverage}
                                      attrName={setVoluntryCoverage}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrycoverage_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Payment Frequency"
                                      value={voluntryPaymentFreq}
                                      attrName={setVoluntryPaymentFreq}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrypaymentfreq_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Value"
                                      value={voluntryValue}
                                      attrName={setVoluntryValue}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntryvalue_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                </Grid>
                                <FeaturesAndExclusion />
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion className="Accordion_section">
                            <AccordionSummary
                              // expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel2a-content"
                              id="panel2a-header"
                            >
                              <Typography className="title">
                                Group Critical illness
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Coverage"
                                      value={voluntryCoverage}
                                      attrName={setVoluntryCoverage}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrycoverage_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Payment Frequency"
                                      value={voluntryPaymentFreq}
                                      attrName={setVoluntryPaymentFreq}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrypaymentfreq_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Value"
                                      value={voluntryValue}
                                      attrName={setVoluntryValue}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntryvalue_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                </Grid>
                                <FeaturesAndExclusion />
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      </Grid>
                    </Grid>
                  ) : null}
                  {voluntaryGradedSectionData === 2 ? (
                    <Grid
                      container
                      spacing={3}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Grid xs={12}>
                        <div>
                          <Accordion
                            className="Accordion_section"
                            expanded={expanded === "panel1"}
                            onChange={handleChange("panel1")}
                          >
                            <AccordionSummary
                              // expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <Typography className="title">
                                Group Personal Accident
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Coverage"
                                      value={voluntryCoverage}
                                      attrName={setVoluntryCoverage}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrycoverage_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Payment Frequency"
                                      value={voluntryPaymentFreq}
                                      attrName={setVoluntryPaymentFreq}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrypaymentfreq_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Value"
                                      value={voluntryValue}
                                      attrName={setVoluntryValue}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntryvalue_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                </Grid>
                                <FeaturesAndExclusion />
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion className="Accordion_section">
                            <AccordionSummary
                              // expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel2a-content"
                              id="panel2a-header"
                            >
                              <Typography className="title">
                                Group Critical illness
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Coverage"
                                      value={voluntryCoverage}
                                      attrName={setVoluntryCoverage}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrycoverage_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Payment Frequency"
                                      value={voluntryPaymentFreq}
                                      attrName={setVoluntryPaymentFreq}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrypaymentfreq_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Value"
                                      value={voluntryValue}
                                      attrName={setVoluntryValue}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntryvalue_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                </Grid>
                                <FeaturesAndExclusion />
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      </Grid>
                    </Grid>
                  ) : null}
                  {voluntaryGradedSectionData === 3 ? (
                    <Grid
                      container
                      spacing={3}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Grid xs={12}>
                        <div>
                          <Accordion
                            className="Accordion_section"
                            expanded={expanded === "panel1"}
                            onChange={handleChange("panel1")}
                          >
                            <AccordionSummary
                              // expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <Typography className="title">
                                Group Personal Accident
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Coverage"
                                      value={voluntryCoverage}
                                      attrName={setVoluntryCoverage}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrycoverage_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Payment Frequency"
                                      value={voluntryPaymentFreq}
                                      attrName={setVoluntryPaymentFreq}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrypaymentfreq_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Value"
                                      value={voluntryValue}
                                      attrName={setVoluntryValue}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntryvalue_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                </Grid>
                                <FeaturesAndExclusion />
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion className="Accordion_section">
                            <AccordionSummary
                              // expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel2a-content"
                              id="panel2a-header"
                            >
                              <Typography className="title">
                                Group Critical illness
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Coverage"
                                      value={voluntryCoverage}
                                      attrName={setVoluntryCoverage}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrycoverage_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Payment Frequency"
                                      value={voluntryPaymentFreq}
                                      attrName={setVoluntryPaymentFreq}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrypaymentfreq_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Value"
                                      value={voluntryValue}
                                      attrName={setVoluntryValue}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntryvalue_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                </Grid>
                                <FeaturesAndExclusion />
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      </Grid>
                    </Grid>
                  ) : null}
                  {voluntaryGradedSectionData === 4 ? (
                    <Grid
                      container
                      spacing={3}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Grid xs={12}>
                        <div>
                          <Accordion
                            className="Accordion_section"
                            expanded={expanded === "panel1"}
                            onChange={handleChange("panel1")}
                          >
                            <AccordionSummary
                              // expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <Typography className="title">
                                Group Personal Accident
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Coverage"
                                      value={voluntryCoverage}
                                      attrName={setVoluntryCoverage}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrycoverage_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Payment Frequency"
                                      value={voluntryPaymentFreq}
                                      attrName={setVoluntryPaymentFreq}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrypaymentfreq_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Value"
                                      value={voluntryValue}
                                      attrName={setVoluntryValue}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntryvalue_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                </Grid>
                                <FeaturesAndExclusion />
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion className="Accordion_section">
                            <AccordionSummary
                              // expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel2a-content"
                              id="panel2a-header"
                            >
                              <Typography className="title">
                                Group Critical illness
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Typography>
                                <Grid container spacing={3}>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Coverage"
                                      value={voluntryCoverage}
                                      attrName={setVoluntryCoverage}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrycoverage_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Payment Frequency"
                                      value={voluntryPaymentFreq}
                                      attrName={setVoluntryPaymentFreq}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntrypaymentfreq_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                  <Grid xs={4}>
                                    <SelectDropdownDisable
                                      class_name="inputField"
                                      title="Value"
                                      value={voluntryValue}
                                      attrName={setVoluntryValue}
                                      value_update={updateMasterState}
                                      dropdown_data={voluntryvalue_data}
                                      warn_status={false}
                                    />
                                  </Grid>
                                </Grid>
                                <FeaturesAndExclusion />
                              </Typography>
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      </Grid>
                    </Grid>
                  ) : null}
                </Box>
              ) : null}

              {/* {viewTabsStatus == "CDLedger" ? (
                <>
                  <CDLedger />
                </>
              ) : null} */}
              {viewTabsStatus == "Logs" ? (
                <>
                  <LogsTable />
                </>
              ) : null}
              {viewTabsStatus == "notes" ? (
                <Box className="detailSection">
                  <div className="sectionTitle">
                    <h4>Notes</h4>

                    <div className="actionBtns">
                      <Link
                        className="blueBtn addfile"
                        sx={{ textDecoration: "none", cursor: "pointer" }}
                        onClick={() => {
                          setPostQueryForm(true);
                        }}
                      >
                        Add Notes
                      </Link>
                    </div>
                  </div>

                  <NotesSection data={notesData} />
                </Box>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <SlidingPanel
        type={"right"}
        isOpen={openContactForm}
        size={75}
        backdropClicked={() => {
          setOpenContactForm(false);
        }}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={12}>
              <h4 className="mb-0 mt-4 ml-0">SPOC Details</h4>
            </Grid>
            <Grid xs={12} className="mb-4">
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area">
            <Grid container spacing={3} className="mt-3">
              <Grid xs={7}>
                <SelectDropdown
                  class_name="inputField"
                  title="Select Contact"
                  value={spocContact}
                  attrName={setSpocContact}
                  value_update={updateMasterState}
                  dropdown_data={spoc_contact_data}
                  warn_status={false}
                />
              </Grid>
              <Grid xs={5} className="mt-2" style={{ textAlign: "right" }}>
                <Link
                  className="greenBtn addfile"
                  underline="none"
                  onClick={() => {
                    navigate("/AddNewContact");
                  }}
                >
                  Create New Contact
                </Link>
              </Grid>
              {spocContact === "EV0065VikasSaini" ||
              spocContact === "EV0016KartikeKakkar" ? (
                <>
                  <Grid xs={6}>
                    <RKTextFieldDisable
                      class_name="inputField"
                      title="Name"
                      value={contactName}
                      attrName={setContactName}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Organization"
                      value={contactOrganization}
                      attrName={setContactOrganization}
                      value_update={updateMasterState}
                      dropdown_data={contact_organization_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Department"
                      value={contactDepartment}
                      attrName={setContactDepartment}
                      value_update={updateMasterState}
                      dropdown_data={contact_department_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Current Job Title"
                      value={jobTitle}
                      attrName={setJobTitle}
                      value_update={updateMasterState}
                      dropdown_data={job_title_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <SelectDropdown
                      class_name="inputField"
                      title="Current Employer"
                      value={currentEmployer}
                      attrName={setCurrentEmployer}
                      value_update={updateMasterState}
                      dropdown_data={current_employer_data}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <RKTextFieldDisable
                      class_name="inputField"
                      title="Email"
                      value={contactEmail}
                      attrName={setContactEmail}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <RKTextFieldDisable
                      class_name="inputField"
                      title="Mobile"
                      value={contactMobile}
                      attrName={setContactMobile}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid xs={6}>
                    <RKTextFieldDisable
                      class_name="inputField"
                      title="Contact number"
                      value={contactNumber}
                      attrName={setContactNumber}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                </>
              ) : null}
            </Grid>
          </div>
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn mt-4">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {}}
              >
                Add SPOC
              </Button>
            </Grid>
          </Grid>
        </div>
      </SlidingPanel>
      <RemovePopup
        open_status={removeCategory}
        attrName={setRemoveCategory}
        value_update={updateMasterState}
      />
      <PostQueryForm
        attrName={setPostQueryForm}
        open_status={postQueryForm}
        value_update={updateMasterState}
      />
    </Box>
  );
}

export default QuoteDetails;
